export default __webpack_public_path__ + "static/media/background-f.e2b05dcd.jpg";